import React from 'react';
import ColorConstants from '../../../constants/ColorConstants';

const defaultProps = {
    color: ColorConstants.silver,
    height: '18px',
    width: '18px',
};


const DragAndDropIcon = ({ color, height, width }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 8 18.909"
        height={height}
        width={width}
    >
        <defs>
            <style>{`.a{fill:${color}}`}</style>
        </defs>
        <g transform="translate(-1745 -551)">
            <circle className="a" cx="1.818" cy="1.818" r="1.818" transform="translate(1745 551)" />
            <circle className="a" cx="1.818" cy="1.818" r="1.818" transform="translate(1749.364 556.091)" />
            <circle className="a" cx="1.818" cy="1.818" r="1.818" transform="translate(1745 556.091)" />
            <circle className="a" cx="1.818" cy="1.818" r="1.818" transform="translate(1749.364 561.182)" />
            <circle className="a" cx="1.818" cy="1.818" r="1.818" transform="translate(1745 561.182)" />
            <circle className="a" cx="1.818" cy="1.818" r="1.818" transform="translate(1749.364 566.272)" />
        </g>
    </svg>
);


DragAndDropIcon.defaultProps = defaultProps;

export default DragAndDropIcon;
